var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "widM txtC padS marTX padBX",
        staticStyle: { "background-color": "#f9f9f9", "border-radius": "15px" }
      },
      [
        _c("p", { staticClass: "fntH6 marTL" }, [
          _c(
            "b",
            {
              staticClass: "osResTag",
              staticStyle: {
                border: "2px solid #303030",
                color: "#303030",
                width: "8em",
                padding: ".45em"
              }
            },
            [_vm._v("신청 기간")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "osResNoticeList" }, [
          _c(
            "ol",
            {
              staticClass: "fntH6 light marTML",
              staticStyle: { "letter-spacing": "-1.5px" }
            },
            [
              _c("li", [
                _c("b", [_vm._v("1차")]),
                _vm._v(" : 2월 8일(화) 오전 10시 ~ 2월 13일(일) 자정(선착순)")
              ]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("2차")]),
                _vm._v(" : 2월 15일(화) 오전 10시 ~ 2월 20일(일) 자정(선착순)")
              ]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("3차")]),
                _vm._v(" : 2월 22일(화) 오전 10시 ~ 2월 27일(일) 자정(선착순)")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fntH6 marTL" }, [
          _c(
            "b",
            {
              staticClass: "osResTag",
              staticStyle: {
                border: "2px solid #303030",
                color: "#303030",
                width: "8em",
                padding: ".45em"
              }
            },
            [_vm._v("참여 방법")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "osResNoticeList txtL marTML widS fntH6" }, [
          _c("ol", [
            _c("li", [
              _vm._v(
                "1. 이벤트 시작 시간에 맞춰 본 이벤트 페이지에서 이벤트 신청"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("2. 팝업창에서 정상 접수 여부를 바로 확인")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("3. 이벤트 종료 익일 신청자 앞으로 발송되는 문자를 확인")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "4. 각 이벤트의 종료일부터 1개월 내에 한국암웨이 홈페이지 또는 모바일 앱에서 제품을 구매"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "5. 구매한 제품과 함께 스킨 뉴트리션 미니 제품이 같이 배송"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fntH6 marTL" }, [
          _c(
            "b",
            {
              staticClass: "osResTag",
              staticStyle: {
                border: "2px solid #303030",
                color: "#303030",
                width: "8em",
                padding: ".45em"
              }
            },
            [_vm._v("유의 사항")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "osResNoticeList txtL marTML widS fntH6" }, [
          _c("ul", [
            _c("li", [
              _vm._v("- 본 이벤트는 한정수량으로 조기 종료될 수 있습니다.")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 본 이벤트는 2022년 1월 1일부터 시작된 A7070 참가자 대상으로 진행되는 이벤트이며 참가하더라도 A7070 참가자가 아닌 경우 추후 증정품 제공이 취소될 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 본 이벤트에 참가하기 위해서는 ABO 번호(또는 소비자 번호)가 필요합니다. 이벤트에 참여하더라도 잘못된 ABO 번호(또는 소비자 번호)를 기입하는 경우 추후 증정품 제공이 취소 또는 전달이 불가능할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 소비자 번호의 확인 방법은 본 페이지 맨 하단에서 확인할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 본 릴레이 이벤트의 증정품은 추후 제품 구매 시 동시 배송됩니다. 이때 주문 채널은 암웨이 홈페이지(www.amway.co.kr) 또는 모바일 앱을 통한 배달 주문만 가능합니다.(스마트 오더, 장바구니 스마트 오더, 전화 및 ARS 주문, 온라인 팩스 주문 및 ABC픽업예약주문, ABC현장주문 불가)"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 증정품 배송은 각 이벤트의 종료일부터 1개월 이내 주문 시에만 적용됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 본 릴레이 이벤트 참여 대상자는 ABO 번호(또는 소비자 번호) 별로 각 차수별로 1회, 총 3회 참여가 가능합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "- 이벤트 정상 접수 여부는 팝업 및 이벤트 종료 익일 발송되는 문자를 통해 확인하실 수 있습니다. 해당 문자를 반드시 확인하시기 바랍니다."
              )
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48c5be7f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48c5be7f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/component/header_info.vue
// module id = null
// module chunks = 